export default defineNuxtRouteMiddleware(async (to, from) => {
  
    const { $fetchVesting } = useNuxtApp();
    await $fetchVesting();


});
